/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, Fragment } from 'react'

import { TRequestContacts } from '~/types'
import { InputWithLabel, SelectWithLabel } from '~/components'
import { STATES } from '~/config'
import { styles } from './styles'

interface ContactsProps {
  disabled: boolean
  contacts: TRequestContacts
  setContacts: (contacts: TRequestContacts) => any
  required?: boolean
}

export const Contacts: FunctionComponent<ContactsProps> = ({
  disabled,
  contacts,
  setContacts,
  required,
}) => (
  <Fragment>
    <div css={styles.side}>
      <InputWithLabel
        label="STREET ADDRESS 1"
        id="address-1"
        name="address-1"
        placeholder="2125 Chestnut Street"
        type="text"
        autoComplete="address-line1"
        required={required}
        tabIndex={21}
        disabled={disabled}
        value={contacts.Address1}
        onChange={(e) =>
          setContacts({
            ...contacts,
            Address1: e.target.value,
          })
        }
      />

      <InputWithLabel
        label="STREET ADDRESS 2"
        id="address-2"
        name="address-2"
        placeholder="San Francisco"
        type="text"
        autoComplete="address-line2"
        tabIndex={22}
        disabled={disabled}
        value={contacts.Address2}
        onChange={(e) =>
          setContacts({
            ...contacts,
            Address2: e.target.value,
          })
        }
      />

      <InputWithLabel
        label="POSTAL CODE"
        id="post-code"
        name="post-code"
        placeholder="94100"
        type="text"
        autoComplete="postal-code"
        tabIndex={25}
        disabled={disabled}
        value={contacts.PostCode}
        onChange={(e) =>
          setContacts({
            ...contacts,
            PostCode: e.target.value,
          })
        }
      />

      <InputWithLabel
        label="COMMENT"
        id="comment"
        name="comment"
        placeholder="..."
        type="text"
        autoComplete="comment"
        tabIndex={27}
        disabled={disabled}
        value={contacts.Comment}
        onChange={(e) =>
          setContacts({
            ...contacts,
            Comment: e.target.value,
          })
        }
      />
    </div>

    <div css={styles.side}>
      <InputWithLabel
        label="CITY"
        id="city"
        name="city"
        placeholder="San Francisco"
        type="text"
        autoComplete="address-level2"
        required={required}
        tabIndex={23}
        disabled={disabled}
        value={contacts.City}
        onChange={(e) =>
          setContacts({
            ...contacts,
            City: e.target.value,
          })
        }
      />

      <SelectWithLabel
        label="STATE"
        id="state"
        name="state"
        placeholder="California"
        autoComplete="address-level1"
        required={required}
        tabIndex={24}
        disabled={disabled}
        options={STATES.map((s) => ({ name: s.name, value: s.abbreviation }))}
        selected={contacts.State || ''}
        onChange={(e: any) =>
          setContacts({
            ...contacts,
            State: e,
          })
        }
      />

      <InputWithLabel
        label="EMAIL"
        id="email"
        name="email"
        placeholder="..."
        type="email"
        autoComplete="email"
        tabIndex={26}
        disabled={disabled}
        value={contacts.Email}
        onChange={(e) =>
          setContacts({
            ...contacts,
            Email: e.target.value,
          })
        }
      />

      <InputWithLabel
        label="PHONE"
        id="phone"
        name="phone"
        placeholder="..."
        type="tel"
        autoComplete="tel"
        tabIndex={28}
        disabled={disabled}
        value={contacts.Phone}
        onChange={(e) =>
          setContacts({
            ...contacts,
            Phone: e.target.value,
          })
        }
      />
    </div>
  </Fragment>
)
